import './polyfills';
import App from './App.vue';
import router from './router';
import store from './store';
import { createApp } from 'vue';
import vuetify from './plugins/vuetify';
import VueSocketIO from 'vue-3-socket.io';
import { createSocketInstance } from './socket';

const initApp = async () => {
  const ioInstance = await createSocketInstance();
  const app = createApp(App);

  app.use(
    new VueSocketIO({
      debug: true,
      connection: ioInstance.socket,
      vuex: {
        store,
        actionPrefix: 'socket_',
        mutationPrefix: 'socket_',
      },
    }),
    ioInstance.socket,
    store,
  );

  app.use(router);
  app.use(store);
  app.use(vuetify);
  app.mount('#app');
};

initApp().catch((error) => {
  console.error('App init failed', error);
});
